import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Checkmark from './components/Checkmark'

const RootContainer = styled.div`
	padding: .5rem 1.2rem;
	border: 1px solid #C7C7C7;
	color: #939393;
	border-radius: 9rem;
	width: 100%;
	display: flex;
	
	${props => props.noBorder && `
		border-color: #C7C7C7;
	`}
	
	
	${props => props.hasErrors && `
		border-color: FireBrick;
	`}
	
	${props => props.textarea && `
			height: 7rem;
	`}
	
	${props => props.inputStyle === 'cornered' && `
		background: white;
		padding: 0.75rem 1.12rem;
		border-color: ${props => props.theme.colors.grayBack};
		border-radius: 0;
	`}
`

const InputStyled = styled.input`
	${props => props.type !== 'checkbox' && `
		padding: 0;
		margin: 0;
		font-size: ${props => props.theme.fontSizes.smallest};
		border: none;
		color: #939393;
		border-radius: 0;
		height: 100%;
		width: 100%;
		resize: none;
	`}
`

const CheckboxStyled = styled.div`
	user-select:none;
	width: 100%;
	font-size: ${props => props.theme.fontSizes.smallest};
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	
	input {
		display: none;
	}
	
	svg {
		transition: ${props => props.theme.transitions.smallElements} ease;
		cursor: pointer;
		margin-right: 0.5rem;
		fill: ${props => props.value ? '#0584FF' : '#D8D8D8'};
	}
`

const Errors = styled.div`
	color: FireBrick;
	font-size: ${props => props.theme.fontSizes.smallest};
	${props => props.padLeft && `
		margin-left: 0.25rem
	`}
`

const Checkbox = ({onChange, placeholder, errors, value, className, ...props}) => {
	return <CheckboxStyled
		className={`checkbox ${className}`}
		value={value}
		onClick={() => onChange({target: {value: !value}})}>
		<Checkmark/> {placeholder} {!!errors.length && <Errors padLeft>{' - '}{errors.join(' ')}</Errors>}
		<input
			{...props}
			type='checkbox'
			checked={value === true}/>
	</CheckboxStyled>
}

Checkbox.defaultProps = {
	onChange: () => undefined,
}

const Textarea = InputStyled.withComponent('textarea')

const Input = ({className, inputProps, errors, textarea, inputStyle, type, noBorder, ...rest}) => {
	let ToRender = InputStyled
	if (type === 'checkbox') return <Checkbox errors={errors} {...rest} className={className} {...inputProps}/>
	if (textarea) ToRender = Textarea

	return <>
		{!!errors.length && <Errors>{errors.map(one => <span key={one}>{one}</span>)}</Errors>}
		<RootContainer
			{...rest}
			inputStyle={inputStyle}
			noBorder={noBorder}
			hasErrors={!!errors.length}
			type={type}
			textarea={textarea}
			className={`textInput ${className}`}>
			<ToRender type={type} {...inputProps}/>
		</RootContainer>
	</>
}

Input.propTypes = {
	className: PropTypes.string,
	inputProps: PropTypes.any,
	textarea: PropTypes.bool,
	noBorder: PropTypes.bool,
	inputStyle: PropTypes.oneOf(['cornered', 'rounded']),
	errors: PropTypes.arrayOf(PropTypes.string.isRequired),
}

Input.defaultProps = {
	className: '',
	textarea: false,
	noBorder: false,
	inputProps: {},
	inputStyle: 'rounded',
	errors: [],
}

export default Input
